// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/Site/HomePage/HomePage.module.css */
/* Container principal */
.HomePage_container__yUsCv {
    font-family: Arial, sans-serif;
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    position: relative;
}

.HomePage_menuVisible__\\+ON\\+5 {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    opacity: 1;
    transform: translateY(0);
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
    z-index: 1000;
    /* Mantém o menu acima do conteúdo */
}

.HomePage_menuHidden__xFaF6 {
    display: none;
    /* Remove o menu completamente quando oculto */
    opacity: 0;
    transform: translateY(-100%);
    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
}

/* ------------------- Seção Hero com vídeo ------------------- */
.HomePage_hero__6\\+UBj {
    height: 100vh;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    overflow: hidden;
    text-align: center;
}

.HomePage_videoBackground__hIS\\+7 {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -2;
}

.HomePage_gradientOverlay__FGnaA {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
    z-index: -1;
}

.HomePage_heroContent__-ejWK {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 90%;
    max-width: 1300px;
    min-height: 70vh;
    z-index: 1;
}

.HomePage_leftColumn__xZSKK {
    flex: 1 1;
    text-align: right;
}

.HomePage_rightColumn__hXKGy {
    flex: 1 1;
    display: flex;
    text-align: left;
    flex-direction: column;
    align-items: top;
    gap: 15px;
}

.HomePage_hero__6\\+UBj h1 {
    font-size: 5.5em;
    line-height: 1.2;
    font-weight: bold;
    max-width: 600px;
    color: #ffffff;
    margin: 0;
}

.HomePage_subTitle__2mBjj {
    font-size: 3em;
    margin: 15px 0;
    color: #ffffff;
    max-width: 500px;
}

.HomePage_ctaButton__08aX7 {
    width: 100%;
    max-width: 250px;
    padding: 15px 0;
    background-color: #ffffff;
    color: #333;
    border: none;
    border-radius: 10px;
    font-size: 1.5em;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    text-align: center;
    font-weight: bold;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.HomePage_ctaButton__08aX7:hover {
    background-color: #bababa;
    color: #1e1e1e;
}

/* ------------------- Seção About Us ------------------- */
.HomePage_aboutUs__SD1io {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #1e1e1e;
    color: white;
    padding: 20px;
}

.HomePage_aboutUsContent__CRBoN{ 
    width: 97%;
    height: 92%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background-color: white;
    color: #333;
    padding: 20px;
    border-radius: 10px;
}

.HomePage_aboutUs__SD1io h2 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3.4rem;
    margin-bottom: 1rem;
    color:#1e1e1e
}

.HomePage_aboutUs__SD1io p {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 1.5rem;
    margin-left: 7rem;
    margin-right: 7rem;
    color:#1e1e1e;
}

.HomePage_aboutUs__SD1io p2 {
    font-size: 1.5rem;
    text-align: center;
    margin-bottom: 2.7rem;
    margin-left: 7rem;
    margin-right: 7rem;
    color: #1e1e1e;
}

.HomePage_aboutUs__SD1io p_end {
    font-size: 1.7rem;
    text-align: center;
    margin-bottom: 2.5rem;
    margin-left: 7rem;
    margin-right: 7rem;
    color: #1e1e1e;
}

.HomePage_aboutUsButton__6sAsW{
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    width: 100%;
    max-width: 250px;
    padding: 15px 0;
    background-color: #1e1e1e;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-size: 1.5em;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    text-align: center;
    font-weight: bold;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
    text-decoration: none;
}

.HomePage_aboutUsButton__6sAsW:hover {
    background-color: #3e3e3e;
    color: #ffffff;
}

/* ------------------- Seção Plan Visit ------------------- */
.HomePage_planVisit__UjVJ\\+ {
    width: 100vw;
    height: 100vh;
    display: flex;
    position: relative;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
}

.HomePage_planVisitImage__Z-tw3 {
    width: 50vw;
    height: 100vh;
    position: relative;
    overflow: hidden;
}

.HomePage_planVisitImage__Z-tw3 img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
}

.HomePage_planVisitContent__hhprk {
    width: 50vw;
    height: 100vh;
    display: flex;
    align-items: center;
    background-color: #ffffff;
    padding: 0 8%;
}

.HomePage_contentWrapper__Dyo2a {
    max-width: 600px;
}

.HomePage_serviceTime__BsQS8 {
    display: block;
    font-size: 1.1rem;
    color: #1e1e1e;
    margin-bottom: 1rem;
}

.HomePage_contentWrapper__Dyo2a h2 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3.4rem;
    margin-bottom: 2rem;
    color: #1e1e1e;
}

.HomePage_contentWrapper__Dyo2a p {
    font-size: 1.25rem;
    line-height: 1.6;
    margin-bottom: 2.5rem;
    color: #1e1e1e;
}

.HomePage_PlanVisitButton__8Uqrn {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    width: 100%;
    max-width: 250px;
    padding: 15px 0;
    background-color: #1e1e1e;
    color: #ffffff;
    border: none;
    border-radius: 10px;
    font-size: 1.5em;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    text-align: center;
    font-weight: bold;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}

.HomePage_PlanVisitButton__8Uqrn:hover {
    background-color: #3e3e3e;
    color: #ffffff;
}


/* ------------------- Seção Staff + Calendar ------------------- */
.HomePage_staffCalendar__6GL0P {
    width: 100vw;
    height: 100vh;
    display: flex;
    background-color: #1e1e1e;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
}

.HomePage_staffSection__Pnqv2,
.HomePage_calendarSection__bVg9T {
    width: 50%;
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.HomePage_imageContainer__irTTK {
    flex: 1 1;
    /* Changed from height: 50% to flex: 1 */
    width: 100%;
    position: relative;
    overflow: hidden;
    aspect-ratio: 16/9;
    /* Added to maintain consistent aspect ratio */
    max-height: 50vh;
    /* Added to ensure it doesn't exceed 50% of viewport height */
}

.HomePage_imageContainer__irTTK img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: absolute;
    top: 0;
    left: 0;
}

.HomePage_contentContainer__dRFS8 {
    flex: 1 1;
    /* Changed from height: 50% to flex: 1 */
    padding: 8%;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.HomePage_sectionLabel__7QvAI {
    font-size: 1rem;
    color: #ffffff;
    margin-bottom: 1.5rem;
}

.HomePage_contentContainer__dRFS8 h2 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3.4rem;
    color: #ffffff;
    margin-top: 0%;
    margin-bottom: 2.5rem;
}

.HomePage_contentContainer__dRFS8 p {
    margin-top: 0%;
    font-size: 1.25rem;
    line-height: 1.6;
    color: #ffffff;
    margin-bottom: 1rem;
}

.HomePage_eventTimes__veT8s {
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.HomePage_eventTimes__veT8s p {
    margin-bottom: 0.5rem;
    font-size: 1.125rem;
}

.HomePage_eventTimes__veT8s strong {
    font-weight: 600;
}

/* ------------------- Seção Next Steps ------------------- */
.HomePage_nextSteps__GXlNA {
    width: 100vw;
    height: 100vh;
    display: flex;
    position: relative;
    margin-left: calc(-50vw + 50%);
    margin-right: calc(-50vw + 50%);
}

.HomePage_nextSteps__GXlNA h2 {
    font-family: "Space Grotesk", sans-serif;
    font-optical-sizing: auto;
    font-weight: 700;
    font-style: normal;
    font-size: 3.4rem;
    margin-bottom: 2rem;
    color: #1e1e1e;
}

.HomePage_nextSteps__GXlNA p {
    font-size: 1.25rem;
    line-height: 1.6;
    margin-bottom: 2.5rem;
    color: #1e1e1e;
}

/* Media queries for mobile devices */
@media screen and (max-width: 768px) {

    /* Hero Section Mobile */
    .HomePage_heroContent__-ejWK {
        flex-direction: column;
        justify-content: center;
        text-align: center;
        padding: 20px;
        gap: 30px;
        width: 100%;
        min-height: 60vh;
    }

    .HomePage_leftColumn__xZSKK {
        text-align: center;
        width: 100%;
    }

    .HomePage_hero__6\\+UBj h1 {
        font-size: clamp(2em, 8vw, 3em);
        text-align: center;
        width: 100%;
        margin: 0 auto;
    }

    .HomePage_rightColumn__hXKGy {
        align-items: center;
        width: 100%;
    }

    .HomePage_subTitle__2mBjj {
        font-size: clamp(1.5em, 6vw, 2em);
        text-align: center;
        width: 100%;
        margin: 10px auto;
    }

    .HomePage_ctaButton__08aX7 {
        width: 80%;
        max-width: 250px;
        font-size: clamp(1rem, 4vw, 1.5em);
    }

    /* About Us Section Mobile */
    .HomePage_aboutUs__SD1io {
        height: 100vh;
        padding: 10px;
        width: 100%;
    }

    .HomePage_aboutUsContent__CRBoN {
        height: 98%;
        padding: 15px;
        justify-content: center;
        width: 95%;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }

    .HomePage_aboutUs__SD1io h2 {
        font-size: clamp(1.8rem, 7vw, 2.5rem);
        margin-bottom: 0.8rem;
        padding: 0 10px;
    }

    .HomePage_aboutUs__SD1io p,
    .HomePage_aboutUs__SD1io p2 {
        font-size: clamp(0.9rem, 3.5vw, 1.2rem);
        margin: 0.8rem 10px;
        padding: 0 5px;
    }

    .HomePage_aboutUs__SD1io p_end {
        font-size: clamp(1rem, 4vw, 1.4rem);
        margin: 1rem 10px;
        padding: 0 5px;
    }

    .HomePage_aboutUsButton__6sAsW {
        width: 80%;
        max-width: 250px;
        font-size: clamp(1rem, 4vw, 1.5em);
        margin: 10px auto;
    }

    /* Plan Visit Section Mobile */
    .HomePage_planVisit__UjVJ\\+ {
        flex-direction: column;
        height: 100vh;
        width: 100vw;
    }

    .HomePage_planVisitImage__Z-tw3 {
        width: 100%;
        height: 50vh;
    }

    .HomePage_planVisitContent__hhprk {
        width: 100%;
        height: 50vh;
        padding: 20px;
    }

    .HomePage_contentWrapper__Dyo2a {
        width: 100%;
        padding: 0 10px;
    }

    .HomePage_contentWrapper__Dyo2a h2 {
        font-size: clamp(1.8rem, 7vw, 2.5rem);
        margin-bottom: 1rem;
    }

    .HomePage_contentWrapper__Dyo2a p {
        font-size: clamp(0.9rem, 3.5vw, 1.1rem);
        margin-bottom: 1.5rem;
    }

    .HomePage_PlanVisitButton__8Uqrn {
        width: 80%;
        max-width: 250px;
        font-size: clamp(1rem, 4vw, 1.5em);
    }

    /* Staff Calendar Section Mobile */
    .HomePage_staffCalendar__6GL0P {
        flex-direction: column;
        height: 200vh;
        width: 100vw;
    }

    .HomePage_staffSection__Pnqv2,
    .HomePage_calendarSection__bVg9T {
        width: 100%;
        height: 100vh;
    }

    .HomePage_imageContainer__irTTK {
        height: 50vh;
        max-height: none;
        width: 100%;
    }

    .HomePage_contentContainer__dRFS8 {
        padding: 20px;
        width: 100%;
        box-sizing: border-box;
    }

    .HomePage_contentContainer__dRFS8 h2 {
        font-size: clamp(1.8rem, 7vw, 2.5rem);
        margin-bottom: 1.5rem;
    }

    .HomePage_contentContainer__dRFS8 p {
        font-size: clamp(0.9rem, 3.5vw, 1.1rem);
    }

    .HomePage_eventTimes__veT8s p {
        font-size: clamp(0.8rem, 3vw, 1rem);
    }

    /* Next Steps Section Mobile */
    .HomePage_nextSteps__GXlNA {
        flex-direction: column;
        height: 100vh;
        width: 100vw;
    }

    .HomePage_nextSteps__GXlNA .HomePage_planVisitContent__hhprk {
        order: 2;
        width: 100%;
    }

    .HomePage_nextSteps__GXlNA .HomePage_planVisitImage__Z-tw3 {
        order: 1;
        width: 100%;
    }

    /* Footer Fix */
    footer {
        width: 100% !important;
        max-width: 100% !important;
        overflow-x: hidden !important;
        position: relative !important;
        box-sizing: border-box !important;
        left: 0 !important;
        right: 0 !important;
        margin: 0 !important;
    }
}

/* Additional fixes for ultra-narrow screens */
@media screen and (max-width: 380px) {
    .HomePage_heroContent__-ejWK {
        gap: 20px;
    }

    .HomePage_aboutUsContent__CRBoN {
        width: 92%;
        padding: 10px;
    }

    .HomePage_aboutUs__SD1io p,
    .HomePage_aboutUs__SD1io p2,
    .HomePage_aboutUs__SD1io p_end {
        margin: 0.6rem 5px;
        padding: 0;
    }

    .HomePage_contentWrapper__Dyo2a,
    .HomePage_contentContainer__dRFS8 {
        padding: 15px;
    }

    .HomePage_eventTimes__veT8s {
        margin-top: 0.5rem;
        margin-bottom: 0.5rem;
    }

    /* Ajuste para evitar overflow horizontal em qualquer situação */
    .HomePage_planVisit__UjVJ\\+,
    .HomePage_staffCalendar__6GL0P,
    .HomePage_nextSteps__GXlNA {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        left: 0;
        right: 0;
    }
}

/* Prevent horizontal scroll on all screen sizes */
html,
body {
    max-width: 100%;
    overflow-x: hidden;
}`, "",{"version":3,"sources":["webpack://./src/pages/Site/HomePage/HomePage.module.css"],"names":[],"mappings":"AAAA,gDAAgD;AAChD,wBAAwB;AACxB;IACI,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,UAAU;IACV,wBAAwB;IACxB,gEAAgE;IAChE,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,8CAA8C;IAC9C,UAAU;IACV,4BAA4B;IAC5B,gEAAgE;AACpE;;AAEA,iEAAiE;AACjE;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oEAAoE;IACpE,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,2DAA2D;AAC3D;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB;AACJ;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA,6DAA6D;AAC7D;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,iBAAiB;IACjB,2CAA2C;AAC/C;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA,mEAAmE;AACnE;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,yBAAyB;IACzB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,UAAU;IACV,aAAa;IACb,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,SAAO;IACP,wCAAwC;IACxC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;IAC9C,gBAAgB;IAChB,6DAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,SAAO;IACP,wCAAwC;IACxC,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA,6DAA6D;AAC7D;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,kBAAkB;IAClB,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;IACI,wCAAwC;IACxC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA,qCAAqC;AACrC;;IAEI,wBAAwB;IACxB;QACI,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,aAAa;QACb,SAAS;QACT,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,+BAA+B;QAC/B,kBAAkB;QAClB,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,iCAAiC;QACjC,kBAAkB;QAClB,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,kCAAkC;IACtC;;IAEA,4BAA4B;IAC5B;QACI,aAAa;QACb,aAAa;QACb,WAAW;IACf;;IAEA;QACI,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,UAAU;QACV,gBAAgB;QAChB,iCAAiC;IACrC;;IAEA;QACI,qCAAqC;QACrC,qBAAqB;QACrB,eAAe;IACnB;;IAEA;;QAEI,uCAAuC;QACvC,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,mCAAmC;QACnC,iBAAiB;QACjB,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,kCAAkC;QAClC,iBAAiB;IACrB;;IAEA,8BAA8B;IAC9B;QACI,sBAAsB;QACtB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,qCAAqC;QACrC,mBAAmB;IACvB;;IAEA;QACI,uCAAuC;QACvC,qBAAqB;IACzB;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,kCAAkC;IACtC;;IAEA,kCAAkC;IAClC;QACI,sBAAsB;QACtB,aAAa;QACb,YAAY;IAChB;;IAEA;;QAEI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;QACb,WAAW;QACX,sBAAsB;IAC1B;;IAEA;QACI,qCAAqC;QACrC,qBAAqB;IACzB;;IAEA;QACI,uCAAuC;IAC3C;;IAEA;QACI,mCAAmC;IACvC;;IAEA,8BAA8B;IAC9B;QACI,sBAAsB;QACtB,aAAa;QACb,YAAY;IAChB;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,WAAW;IACf;;IAEA,eAAe;IACf;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,6BAA6B;QAC7B,6BAA6B;QAC7B,iCAAiC;QACjC,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;IACxB;AACJ;;AAEA,8CAA8C;AAC9C;IACI;QACI,SAAS;IACb;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;;;QAGI,kBAAkB;QAClB,UAAU;IACd;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA,gEAAgE;IAChE;;;QAGI,WAAW;QACX,cAAc;QACd,eAAe;QACf,OAAO;QACP,QAAQ;IACZ;AACJ;;AAEA,kDAAkD;AAClD;;IAEI,eAAe;IACf,kBAAkB;AACtB","sourcesContent":["/* src/pages/Site/HomePage/HomePage.module.css */\r\n/* Container principal */\r\n.container {\r\n    font-family: Arial, sans-serif;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow-x: hidden;\r\n    position: relative;\r\n}\r\n\r\n.menuVisible {\r\n    display: block;\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;\r\n    z-index: 1000;\r\n    /* Mantém o menu acima do conteúdo */\r\n}\r\n\r\n.menuHidden {\r\n    display: none;\r\n    /* Remove o menu completamente quando oculto */\r\n    opacity: 0;\r\n    transform: translateY(-100%);\r\n    transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;\r\n}\r\n\r\n/* ------------------- Seção Hero com vídeo ------------------- */\r\n.hero {\r\n    height: 100vh;\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: white;\r\n    overflow: hidden;\r\n    text-align: center;\r\n}\r\n\r\n.videoBackground {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    z-index: -2;\r\n}\r\n\r\n.gradientOverlay {\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);\r\n    z-index: -1;\r\n}\r\n\r\n.heroContent {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 90%;\r\n    max-width: 1300px;\r\n    min-height: 70vh;\r\n    z-index: 1;\r\n}\r\n\r\n.leftColumn {\r\n    flex: 1;\r\n    text-align: right;\r\n}\r\n\r\n.rightColumn {\r\n    flex: 1;\r\n    display: flex;\r\n    text-align: left;\r\n    flex-direction: column;\r\n    align-items: top;\r\n    gap: 15px;\r\n}\r\n\r\n.hero h1 {\r\n    font-size: 5.5em;\r\n    line-height: 1.2;\r\n    font-weight: bold;\r\n    max-width: 600px;\r\n    color: #ffffff;\r\n    margin: 0;\r\n}\r\n\r\n.subTitle {\r\n    font-size: 3em;\r\n    margin: 15px 0;\r\n    color: #ffffff;\r\n    max-width: 500px;\r\n}\r\n\r\n.ctaButton {\r\n    width: 100%;\r\n    max-width: 250px;\r\n    padding: 15px 0;\r\n    background-color: #ffffff;\r\n    color: #333;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-size: 1.5em;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, color 0.3s;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.ctaButton:hover {\r\n    background-color: #bababa;\r\n    color: #1e1e1e;\r\n}\r\n\r\n/* ------------------- Seção About Us ------------------- */\r\n.aboutUs {\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    background-color: #1e1e1e;\r\n    color: white;\r\n    padding: 20px;\r\n}\r\n\r\n.aboutUsContent{ \r\n    width: 97%;\r\n    height: 92%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: white;\r\n    color: #333;\r\n    padding: 20px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.aboutUs h2 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 3.4rem;\r\n    margin-bottom: 1rem;\r\n    color:#1e1e1e\r\n}\r\n\r\n.aboutUs p {\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n    margin-bottom: 1.5rem;\r\n    margin-left: 7rem;\r\n    margin-right: 7rem;\r\n    color:#1e1e1e;\r\n}\r\n\r\n.aboutUs p2 {\r\n    font-size: 1.5rem;\r\n    text-align: center;\r\n    margin-bottom: 2.7rem;\r\n    margin-left: 7rem;\r\n    margin-right: 7rem;\r\n    color: #1e1e1e;\r\n}\r\n\r\n.aboutUs p_end {\r\n    font-size: 1.7rem;\r\n    text-align: center;\r\n    margin-bottom: 2.5rem;\r\n    margin-left: 7rem;\r\n    margin-right: 7rem;\r\n    color: #1e1e1e;\r\n}\r\n\r\n.aboutUsButton{\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    width: 100%;\r\n    max-width: 250px;\r\n    padding: 15px 0;\r\n    background-color: #1e1e1e;\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-size: 1.5em;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, color 0.3s;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n    text-decoration: none;\r\n}\r\n\r\n.aboutUsButton:hover {\r\n    background-color: #3e3e3e;\r\n    color: #ffffff;\r\n}\r\n\r\n/* ------------------- Seção Plan Visit ------------------- */\r\n.planVisit {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    position: relative;\r\n    margin-left: calc(-50vw + 50%);\r\n    margin-right: calc(-50vw + 50%);\r\n}\r\n\r\n.planVisitImage {\r\n    width: 50vw;\r\n    height: 100vh;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.planVisitImage img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.planVisitContent {\r\n    width: 50vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #ffffff;\r\n    padding: 0 8%;\r\n}\r\n\r\n.contentWrapper {\r\n    max-width: 600px;\r\n}\r\n\r\n.serviceTime {\r\n    display: block;\r\n    font-size: 1.1rem;\r\n    color: #1e1e1e;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.contentWrapper h2 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 3.4rem;\r\n    margin-bottom: 2rem;\r\n    color: #1e1e1e;\r\n}\r\n\r\n.contentWrapper p {\r\n    font-size: 1.25rem;\r\n    line-height: 1.6;\r\n    margin-bottom: 2.5rem;\r\n    color: #1e1e1e;\r\n}\r\n\r\n.PlanVisitButton {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    width: 100%;\r\n    max-width: 250px;\r\n    padding: 15px 0;\r\n    background-color: #1e1e1e;\r\n    color: #ffffff;\r\n    border: none;\r\n    border-radius: 10px;\r\n    font-size: 1.5em;\r\n    cursor: pointer;\r\n    transition: background-color 0.3s, color 0.3s;\r\n    text-align: center;\r\n    font-weight: bold;\r\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.PlanVisitButton:hover {\r\n    background-color: #3e3e3e;\r\n    color: #ffffff;\r\n}\r\n\r\n\r\n/* ------------------- Seção Staff + Calendar ------------------- */\r\n.staffCalendar {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    background-color: #1e1e1e;\r\n    margin-left: calc(-50vw + 50%);\r\n    margin-right: calc(-50vw + 50%);\r\n}\r\n\r\n.staffSection,\r\n.calendarSection {\r\n    width: 50%;\r\n    height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.imageContainer {\r\n    flex: 1;\r\n    /* Changed from height: 50% to flex: 1 */\r\n    width: 100%;\r\n    position: relative;\r\n    overflow: hidden;\r\n    aspect-ratio: 16/9;\r\n    /* Added to maintain consistent aspect ratio */\r\n    max-height: 50vh;\r\n    /* Added to ensure it doesn't exceed 50% of viewport height */\r\n}\r\n\r\n.imageContainer img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.contentContainer {\r\n    flex: 1;\r\n    /* Changed from height: 50% to flex: 1 */\r\n    padding: 8%;\r\n    color: white;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n}\r\n\r\n.sectionLabel {\r\n    font-size: 1rem;\r\n    color: #ffffff;\r\n    margin-bottom: 1.5rem;\r\n}\r\n\r\n.contentContainer h2 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 3.4rem;\r\n    color: #ffffff;\r\n    margin-top: 0%;\r\n    margin-bottom: 2.5rem;\r\n}\r\n\r\n.contentContainer p {\r\n    margin-top: 0%;\r\n    font-size: 1.25rem;\r\n    line-height: 1.6;\r\n    color: #ffffff;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.eventTimes {\r\n    margin-top: 1rem;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.eventTimes p {\r\n    margin-bottom: 0.5rem;\r\n    font-size: 1.125rem;\r\n}\r\n\r\n.eventTimes strong {\r\n    font-weight: 600;\r\n}\r\n\r\n/* ------------------- Seção Next Steps ------------------- */\r\n.nextSteps {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    display: flex;\r\n    position: relative;\r\n    margin-left: calc(-50vw + 50%);\r\n    margin-right: calc(-50vw + 50%);\r\n}\r\n\r\n.nextSteps h2 {\r\n    font-family: \"Space Grotesk\", sans-serif;\r\n    font-optical-sizing: auto;\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-size: 3.4rem;\r\n    margin-bottom: 2rem;\r\n    color: #1e1e1e;\r\n}\r\n\r\n.nextSteps p {\r\n    font-size: 1.25rem;\r\n    line-height: 1.6;\r\n    margin-bottom: 2.5rem;\r\n    color: #1e1e1e;\r\n}\r\n\r\n/* Media queries for mobile devices */\r\n@media screen and (max-width: 768px) {\r\n\r\n    /* Hero Section Mobile */\r\n    .heroContent {\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        text-align: center;\r\n        padding: 20px;\r\n        gap: 30px;\r\n        width: 100%;\r\n        min-height: 60vh;\r\n    }\r\n\r\n    .leftColumn {\r\n        text-align: center;\r\n        width: 100%;\r\n    }\r\n\r\n    .hero h1 {\r\n        font-size: clamp(2em, 8vw, 3em);\r\n        text-align: center;\r\n        width: 100%;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    .rightColumn {\r\n        align-items: center;\r\n        width: 100%;\r\n    }\r\n\r\n    .subTitle {\r\n        font-size: clamp(1.5em, 6vw, 2em);\r\n        text-align: center;\r\n        width: 100%;\r\n        margin: 10px auto;\r\n    }\r\n\r\n    .ctaButton {\r\n        width: 80%;\r\n        max-width: 250px;\r\n        font-size: clamp(1rem, 4vw, 1.5em);\r\n    }\r\n\r\n    /* About Us Section Mobile */\r\n    .aboutUs {\r\n        height: 100vh;\r\n        padding: 10px;\r\n        width: 100%;\r\n    }\r\n\r\n    .aboutUsContent {\r\n        height: 98%;\r\n        padding: 15px;\r\n        justify-content: center;\r\n        width: 95%;\r\n        overflow-y: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n    }\r\n\r\n    .aboutUs h2 {\r\n        font-size: clamp(1.8rem, 7vw, 2.5rem);\r\n        margin-bottom: 0.8rem;\r\n        padding: 0 10px;\r\n    }\r\n\r\n    .aboutUs p,\r\n    .aboutUs p2 {\r\n        font-size: clamp(0.9rem, 3.5vw, 1.2rem);\r\n        margin: 0.8rem 10px;\r\n        padding: 0 5px;\r\n    }\r\n\r\n    .aboutUs p_end {\r\n        font-size: clamp(1rem, 4vw, 1.4rem);\r\n        margin: 1rem 10px;\r\n        padding: 0 5px;\r\n    }\r\n\r\n    .aboutUsButton {\r\n        width: 80%;\r\n        max-width: 250px;\r\n        font-size: clamp(1rem, 4vw, 1.5em);\r\n        margin: 10px auto;\r\n    }\r\n\r\n    /* Plan Visit Section Mobile */\r\n    .planVisit {\r\n        flex-direction: column;\r\n        height: 100vh;\r\n        width: 100vw;\r\n    }\r\n\r\n    .planVisitImage {\r\n        width: 100%;\r\n        height: 50vh;\r\n    }\r\n\r\n    .planVisitContent {\r\n        width: 100%;\r\n        height: 50vh;\r\n        padding: 20px;\r\n    }\r\n\r\n    .contentWrapper {\r\n        width: 100%;\r\n        padding: 0 10px;\r\n    }\r\n\r\n    .contentWrapper h2 {\r\n        font-size: clamp(1.8rem, 7vw, 2.5rem);\r\n        margin-bottom: 1rem;\r\n    }\r\n\r\n    .contentWrapper p {\r\n        font-size: clamp(0.9rem, 3.5vw, 1.1rem);\r\n        margin-bottom: 1.5rem;\r\n    }\r\n\r\n    .PlanVisitButton {\r\n        width: 80%;\r\n        max-width: 250px;\r\n        font-size: clamp(1rem, 4vw, 1.5em);\r\n    }\r\n\r\n    /* Staff Calendar Section Mobile */\r\n    .staffCalendar {\r\n        flex-direction: column;\r\n        height: 200vh;\r\n        width: 100vw;\r\n    }\r\n\r\n    .staffSection,\r\n    .calendarSection {\r\n        width: 100%;\r\n        height: 100vh;\r\n    }\r\n\r\n    .imageContainer {\r\n        height: 50vh;\r\n        max-height: none;\r\n        width: 100%;\r\n    }\r\n\r\n    .contentContainer {\r\n        padding: 20px;\r\n        width: 100%;\r\n        box-sizing: border-box;\r\n    }\r\n\r\n    .contentContainer h2 {\r\n        font-size: clamp(1.8rem, 7vw, 2.5rem);\r\n        margin-bottom: 1.5rem;\r\n    }\r\n\r\n    .contentContainer p {\r\n        font-size: clamp(0.9rem, 3.5vw, 1.1rem);\r\n    }\r\n\r\n    .eventTimes p {\r\n        font-size: clamp(0.8rem, 3vw, 1rem);\r\n    }\r\n\r\n    /* Next Steps Section Mobile */\r\n    .nextSteps {\r\n        flex-direction: column;\r\n        height: 100vh;\r\n        width: 100vw;\r\n    }\r\n\r\n    .nextSteps .planVisitContent {\r\n        order: 2;\r\n        width: 100%;\r\n    }\r\n\r\n    .nextSteps .planVisitImage {\r\n        order: 1;\r\n        width: 100%;\r\n    }\r\n\r\n    /* Footer Fix */\r\n    :global(footer) {\r\n        width: 100% !important;\r\n        max-width: 100% !important;\r\n        overflow-x: hidden !important;\r\n        position: relative !important;\r\n        box-sizing: border-box !important;\r\n        left: 0 !important;\r\n        right: 0 !important;\r\n        margin: 0 !important;\r\n    }\r\n}\r\n\r\n/* Additional fixes for ultra-narrow screens */\r\n@media screen and (max-width: 380px) {\r\n    .heroContent {\r\n        gap: 20px;\r\n    }\r\n\r\n    .aboutUsContent {\r\n        width: 92%;\r\n        padding: 10px;\r\n    }\r\n\r\n    .aboutUs p,\r\n    .aboutUs p2,\r\n    .aboutUs p_end {\r\n        margin: 0.6rem 5px;\r\n        padding: 0;\r\n    }\r\n\r\n    .contentWrapper,\r\n    .contentContainer {\r\n        padding: 15px;\r\n    }\r\n\r\n    .eventTimes {\r\n        margin-top: 0.5rem;\r\n        margin-bottom: 0.5rem;\r\n    }\r\n\r\n    /* Ajuste para evitar overflow horizontal em qualquer situação */\r\n    .planVisit,\r\n    .staffCalendar,\r\n    .nextSteps {\r\n        width: 100%;\r\n        margin-left: 0;\r\n        margin-right: 0;\r\n        left: 0;\r\n        right: 0;\r\n    }\r\n}\r\n\r\n/* Prevent horizontal scroll on all screen sizes */\r\nhtml,\r\nbody {\r\n    max-width: 100%;\r\n    overflow-x: hidden;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HomePage_container__yUsCv`,
	"menuVisible": `HomePage_menuVisible__+ON+5`,
	"menuHidden": `HomePage_menuHidden__xFaF6`,
	"hero": `HomePage_hero__6+UBj`,
	"videoBackground": `HomePage_videoBackground__hIS+7`,
	"gradientOverlay": `HomePage_gradientOverlay__FGnaA`,
	"heroContent": `HomePage_heroContent__-ejWK`,
	"leftColumn": `HomePage_leftColumn__xZSKK`,
	"rightColumn": `HomePage_rightColumn__hXKGy`,
	"subTitle": `HomePage_subTitle__2mBjj`,
	"ctaButton": `HomePage_ctaButton__08aX7`,
	"aboutUs": `HomePage_aboutUs__SD1io`,
	"aboutUsContent": `HomePage_aboutUsContent__CRBoN`,
	"aboutUsButton": `HomePage_aboutUsButton__6sAsW`,
	"planVisit": `HomePage_planVisit__UjVJ+`,
	"planVisitImage": `HomePage_planVisitImage__Z-tw3`,
	"planVisitContent": `HomePage_planVisitContent__hhprk`,
	"contentWrapper": `HomePage_contentWrapper__Dyo2a`,
	"serviceTime": `HomePage_serviceTime__BsQS8`,
	"PlanVisitButton": `HomePage_PlanVisitButton__8Uqrn`,
	"staffCalendar": `HomePage_staffCalendar__6GL0P`,
	"staffSection": `HomePage_staffSection__Pnqv2`,
	"calendarSection": `HomePage_calendarSection__bVg9T`,
	"imageContainer": `HomePage_imageContainer__irTTK`,
	"contentContainer": `HomePage_contentContainer__dRFS8`,
	"sectionLabel": `HomePage_sectionLabel__7QvAI`,
	"eventTimes": `HomePage_eventTimes__veT8s`,
	"nextSteps": `HomePage_nextSteps__GXlNA`
};
export default ___CSS_LOADER_EXPORT___;
